export const MOBILE_WEB_TO_APP_BANNER_EXPERIMENT = 'aud_mobile_aud3085_web_to_app_banners_frequency_v2';

export const EXPERIMENTS = [MOBILE_WEB_TO_APP_BANNER_EXPERIMENT];
